import { Button, Icons } from '@cast/design-system';

type Props = {
  href: string;
  /** Visible label. Default "Learn more". */
  label?: string;
  testId?: string;
};

/**
 * DocsTextButton — text-style external link to documentation, rendered as a
 * DS text Button with the arrow-square-out icon. Replaces the previous
 * underlined-anchor "Learn more / Documentation" pattern.
 */
export const DocsTextButton = ({
  href,
  label = 'Learn more',
  testId,
}: Props) => (
  <Button
    variant="text"
    size="md"
    component="a"
    href={href}
    target="_blank"
    rel="noreferrer noopener"
    endIcon={<Icons.ArrowSquareOut size={14} />}
    testId={testId}
  >
    {label}
  </Button>
);
